import { developmentConfig } from './development';
import { productionConfig } from './production';
import { stagingConfig } from './staging';

// Get environment from process.env with fallback
const getEnvironment = (): string => {
  // Check Expo environment variables first
  if (process.env.EXPO_PUBLIC_ENVIRONMENT) {
    return process.env.EXPO_PUBLIC_ENVIRONMENT as string;
  }

  // Fallback to NODE_ENV
  if (process.env.NODE_ENV) {
    return process.env.NODE_ENV;
  }

  // Default to development
  return 'development';
};

const environment = getEnvironment();

// Select configuration based on environment
const getConfig = () => {
  switch (environment) {
    case 'production':
      return productionConfig;
    case 'development':
      return developmentConfig;
    case 'staging':
      return stagingConfig;
    default:
      return developmentConfig;
  }
};

export const envConfig = getConfig();
export const currentEnvironment = environment;

// Helper functions
export const isDevelopment = () => environment === 'development';
export const isProduction = () => environment === 'production';
export const isStaging = () => environment === 'staging';
export const isTest = () => environment === 'test';

// Final configuration - no environment variable overrides, pure config-based
export const finalConfig = envConfig;

// No logging of config - avoids exposing API URLs, vendor names, or internal state
